import { bludeltaRequest, BluDeltaResponse } from './network';
import { DetectedClient } from './detectInvoice';

export interface GetClientsParams {
  searchText?: string | null;
  columnName?: string | null;
  ClientId?: string | null;
}
export interface ClientResponse extends BluDeltaResponse {
  Clients: DetectedClient[];
}

export function getClients(params: GetClientsParams): Promise<ClientResponse> {
  let searchString = '';
  if (params.searchText) searchString += `?SearchQuery=${params.searchText}`;
  if (params.columnName) searchString += `&ColumnName=${params.columnName}`;
  if (params.ClientId) searchString += `?ClientId=${params.ClientId}`;
  return bludeltaRequest('GET', `/clientmasterdata${searchString}`);
}
